module.exports = "images/green.0fe6be36406286b7679f9b9feab92c39.png";